import React from "react";
import { CircularProgress } from "@mui/material";

function LoadingSpinner({ size = 40, padding = 3 }) {
  // Convert MUI spacing to pixels (MUI spacing unit = 8px)
  const paddingPx = typeof padding === "number" ? padding * 8 : padding;

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        padding: paddingPx,
      }}
    >
      <CircularProgress size={size} />
    </div>
  );
}

export default LoadingSpinner;
